import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sourcesApi } from '../api/sources.api';
import { sourceKeys } from './queryKeys';

interface ToggleSourceStatusParams {
  id: string;
  isEnabled: boolean;
}

export const useToggleSourceStatus = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ id, isEnabled }: ToggleSourceStatusParams) =>
      sourcesApi.toggleSourceStatus(id, { enable: isEnabled }),
    onSuccess: () => {
      // sourceKeys.all, not lists(): the source detail carries the status too.
      queryClient.invalidateQueries({ queryKey: sourceKeys.all });
    },
  });

  return {
    toggleStatus: mutation.mutate,
    isToggling: mutation.isPending,
  };
};
